import { ENDPOINTS_MANAGER } from 'common/endpoints/vacations-absences.endpoints';
import managerAssembler from './managerRepository.assemblers';

class managerRepositoryService {
  constructor($http, ManagerDataService) {
    'ngInject';
    this.http = $http;
    this.ManagerDataService = ManagerDataService;
  }

  getManager(managerId, year) {
    return this.http.get(ENDPOINTS_MANAGER.get.initial(managerId, year)).then(response => {
      return managerAssembler.assemble(response.data);
    });
  }
}

export default managerRepositoryService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/managerRepository/managerRepository.service.js